<template>
  <div>
    <AboutSection
          :image1="require('@/assets/AllSystem/pthferizaj/image1.jpg')"
          :image2="require('@/assets/AllSystem/pthferizaj/image2.png')"
          :section1="$t('menus.pthferizaj.about_us.section1')"
          :section2Title="$t('menus.pthferizaj.about_us.section2.title')"
          :section2Content="$t('menus.pthferizaj.about_us.section2.content')" />
  </div>
</template>

<script>
 import AboutSection from '../share/AboutUs.vue'


export default {
    components: {
      AboutSection
    },
    computed: {
      administrationObj() {
        return {
          title: this.$t('menus.pthferizaj.about_us.administration.title') || '',
          fullname: this.$t('menus.pthferizaj.about_us.administration.fullname') || '',
          tel: this.$t('menus.pthferizaj.about_us.administration.tel') || '',
          email: this.$t('menus.pthferizaj.about_us.administration.email') || '',
          address: this.$t('menus.pthferizaj.about_us.administration.address') || ''
        };
    }
}

}
</script>

  <style scoped>
  .textBox:first-child{
    border-right:4px solid #F5BD2A;
    padding-right:10px;
  }
  .textBox:nth-child(2){
    border-left:4px solid #F5BD2A;
    padding-left:10px;
  }
  </style>